import React, { useState } from 'react';
import { FileText, KeyRound, Loader2, Mail } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/portal/aml-api/keys`;
const err = (e) => (typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : 'Operazione non riuscita');
const field = 'bg-[#050505] border-[#1F242C] text-white rounded-sm';
const outline = 'h-9 bg-transparent border border-[#1F242C] text-white rounded-sm';

const save = (blob, name) => { const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = name; a.click(); URL.revokeObjectURL(a.href); };

export async function downloadDoc(headers, keyId, apiKey) {
  try {
    const r = apiKey
      ? await axios.post(`${API}/${keyId}/credentials`, { api_key: apiKey }, { headers, responseType: 'blob' })
      : await axios.get(`${API}/${keyId}/guide`, { headers, responseType: 'blob' });
    save(r.data, apiKey ? 'BOND_API_AML_credenziali_RISERVATO.pdf' : 'BOND_API_AML_guida_integrazione.pdf');
  } catch { toast.error('Download non riuscito'); }
}

export function SendDoc({ headers, keyId, apiKey, defaultEmail, testid }) {
  const [email, setEmail] = useState(defaultEmail || '');
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const url = apiKey ? `${API}/${keyId}/credentials/send` : `${API}/${keyId}/guide/send`;
      await axios.post(url, apiKey ? { api_key: apiKey, email } : { email }, { headers });
      toast.success(`${apiKey ? 'Credenziali inviate' : 'Guida inviata'} a ${email}`);
    } catch (e) { toast.error(Array.isArray(e?.response?.data?.detail) ? 'Email non valida' : err(e)); } finally { setBusy(false); }
  };
  return (
    <div className="flex gap-2">
      <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email dello sviluppatore" className={`h-9 flex-1 ${field}`} data-testid={`${testid}-email`} />
      <Button onClick={send} disabled={busy || !email} className="h-9 bg-[#D4AF37] text-black rounded-sm" data-testid={`${testid}-send`}>
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Mail size={14} className="mr-2" />}Invia</Button>
    </div>
  );
}

export function KeyDocs({ k, headers, onRotated }) {
  const [open, setOpen] = useState(false);
  const rotate = async () => {
    if (!window.confirm(`Generare una nuova chiave per «${k.label}»? Quella attuale smette subito di funzionare.`)) return;
    try { const { data } = await axios.post(`${API}/${k.id}/rotate`, null, { headers }); setOpen(false); onRotated(data); } catch (e) { toast.error(err(e)); }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} className="block text-xs text-[#D4AF37]" data-testid={`aml-api-docs-${k.id}`}>Documenti</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#0B0D10] border-[#1F242C] text-white" data-testid="aml-api-docs-dialog">
          <DialogHeader><DialogTitle>Documenti · {k.label}</DialogTitle></DialogHeader>
          <div className="space-y-3 text-sm">
            <p className="text-[#A3A3A3]">Guida all'integrazione per lo sviluppatore (senza chiave, con i prezzi di questa chiave).</p>
            <Button onClick={() => downloadDoc(headers, k.id)} className={outline} data-testid="aml-api-guide-download"><FileText size={14} className="mr-2" />Scarica guida PDF</Button>
            <SendDoc headers={headers} keyId={k.id} defaultEmail={k.user?.email} testid="aml-api-guide" />
            <div className="border-t border-[#1F242C] pt-3">
              <p className="text-[#A3A3A3] mb-2">Il documento con la chiave si può creare solo quando la chiave viene generata: BOND non la conserva. Per inviarla di nuovo genera una nuova chiave.</p>
              <Button onClick={rotate} className={outline} data-testid="aml-api-rotate"><KeyRound size={14} className="mr-2" />Genera nuova chiave</Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
